import {toaster} from '../toaster.js'
import {useQuery} from '@rocicorp/zero/react'
import {useNavigate} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import {useEffect, useRef} from 'react'

interface Config {
  resource: unknown
  queryState: ReturnType<typeof useQuery>[1]
  shouldGuard: boolean
}

export function useGuardNonexistentResourceForm({resource, queryState, shouldGuard}: Config) {
  const {t} = useTranslate('common')
  const navigate = useNavigate()
  const navigated = useRef(false)

  useEffect(() => {
    if (queryState?.type !== 'complete' || resource || navigated.current || !shouldGuard) return

    navigated.current = true
    navigate({to: '.', search: {}, replace: true})
      .then(() => {
        return toaster.info({description: t('resource_does_not_exist_or_was_deleted')})
      })
      .catch(console.error)
  }, [t, navigate, resource, queryState, shouldGuard])
}
